import script from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&setup=true"

import "./VideoPreview.vue?vue&type=style&index=0&id=f69d035e&lang=less"

const __exports__ = script;

export default __exports__